function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcVisa = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 2571",
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.945,
    height: 62.956,
    viewBox: "0 0 78.945 62.956",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "5vk6hiiqwa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 288",
    d: "M0 0h71.827v23.2H0z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "01_visa"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 735"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 677",
    style: {
      clipPath: "url(#5vk6hiiqwa)"
    },
    transform: "translate(2.424 20.959)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2785",
    d: "m27.271.41-9.4 22.436h-6.139L7.1 4.941a6.7 6.7 0 0 0-.214-.708 2.419 2.419 0 0 0-.261-.517 1.864 1.864 0 0 0-.368-.4 3.436 3.436 0 0 0-.536-.349 11.973 11.973 0 0 0-1.2-.555C4.084 2.234 3.6 2.061 3.1 1.9A32.542 32.542 0 0 0 0 1.062L.138.41h9.876a2.735 2.735 0 0 1 .909.154 2.62 2.62 0 0 1 .794.447 2.686 2.686 0 0 1 .611.718 3.08 3.08 0 0 1 .362.969l2.444 12.982L21.174.41zM51.31 15.521a5.211 5.211 0 0 0-1.268-3.516 10.131 10.131 0 0 0-2.81-2.159c-1.022-.576-2.042-1.05-2.8-1.545s-1.264-1.011-1.25-1.673a1.388 1.388 0 0 1 .156-.6 1.823 1.823 0 0 1 .452-.557 2.767 2.767 0 0 1 .763-.447 4.484 4.484 0 0 1 1.09-.273 7.6 7.6 0 0 1 .879-.057 10.5 10.5 0 0 1 1.319.07 11.452 11.452 0 0 1 1.65.315 11.73 11.73 0 0 1 1.873.677L52.381.995c-.349-.127-.723-.252-1.123-.369S50.433.4 49.982.307s-.93-.169-1.435-.223A15.069 15.069 0 0 0 46.952 0 13.812 13.812 0 0 0 43 .545a9.727 9.727 0 0 0-3.09 1.526 7.076 7.076 0 0 0-2.025 2.345 6.5 6.5 0 0 0-.74 3 4.867 4.867 0 0 0 .469 2.166 6.023 6.023 0 0 0 1.233 1.7A9.912 9.912 0 0 0 40.5 12.57a17.6 17.6 0 0 0 1.727.953c.566.275 1.037.525 1.426.761a5.8 5.8 0 0 1 .932.677 2.179 2.179 0 0 1 .506.655 1.554 1.554 0 0 1 .149.7 1.672 1.672 0 0 1-.315.974 2.343 2.343 0 0 1-.8.678 4.292 4.292 0 0 1-1.113.4 6.246 6.246 0 0 1-1.246.142 12.888 12.888 0 0 1-1.972-.114 10.939 10.939 0 0 1-1.6-.342 12.242 12.242 0 0 1-1.3-.468c-.394-.166-.753-.336-1.09-.492L34.751 22a9.384 9.384 0 0 0 1.216.445c.466.139.987.266 1.547.374s1.158.2 1.779.263 1.264.1 1.913.11a15 15 0 0 0 4.149-.543 9.672 9.672 0 0 0 3.183-1.545 6.959 6.959 0 0 0 2.044-2.42 7.044 7.044 0 0 0 .729-3.167m15.149 7.325h5.368L67.141.41h-4.955a2.737 2.737 0 0 0-.8.117 2.611 2.611 0 0 0-1.268.851 2.741 2.741 0 0 0-.4.678l-8.709 20.79H57.1l1.21-3.351h7.446zM59.983 14.9l3.055-8.424L64.8 14.9zM35.564.41l-4.8 22.436h-5.8L29.762.41z",
    style: {
      fill: "#1434cb"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 366",
    d: "M0 0h78.944v62.956H0z",
    style: {
      fill: "none"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcVisa);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-visa.1f244f912e5540a0c493b935afd36a4c.svg";